import { SET_PRIVILEGES } from "../../CONSTANTS";

export default function setPrivileges({ clientId, privileges }) {
  return {
    type: SET_PRIVILEGES,
    payload: {
      clientId,
      privileges,
    },
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/clients/setPrivileges.js